import React from 'react';

import { PageTitle } from '../../../components';
import { Team } from '../../../sections';

import { useTranslation } from 'react-i18next';
import { titles } from '../../../constants';



const TeamPage = () => {

  const t = useTranslation().t;
  return (
    <>

      {/* Page title */}
      <PageTitle title={t(titles.team)} page={t(titles.team)} />

      {/* Team section */}
      <Team />

    </>
  )

}

export default TeamPage;